import {
  Sun, Moon, Monitor, ChevronDown, ChevronRight, X, AlertCircle,
  TrendingUp, TrendingDown, Settings, LogOut, RefreshCw, Plus,
  Play, Send, LayoutDashboard, KeyRound,
} from 'lucide-preact';

export const Icons = {
  Sun, Moon, Monitor, ChevronDown, ChevronRight, X, AlertCircle,
  TrendingUp, TrendingDown, Settings, LogOut, RefreshCw, Plus,
  Play, Send, LayoutDashboard, KeyRound,
} as const;

export type IconName = keyof typeof Icons;
